<template>
  <card>
    <vue-element-loading
      :text="loading.text"
      spinner="bar-fade-scale"
      :color="loading.color"
      :active="loading.active"
      :is-full-screen="false"/>
    <div slot="header">
      <h4 class="title">Editar Perfíl</h4>
    </div>
    <div>
      <form id="edit_form">
        <div class="row">
          <div class="col-md-6">
            <fg-input type="text"
                      disabled
                      label="Nombre Completo"
                      placeholder="Tu nombre completo"
                      v-model="user.user_name"
                      v-validate="modelValidations.fullName"
                      :error="getError('fullname')"
                      name="fullname">
            </fg-input>
          </div>
          <div class="col-md-6">
            <fg-input type="text"
                      disabled
                      label="Usuario"
                      placeholder="Tu usuario"
                      v-model="user.username"
                      v-validate="modelValidations.username"
                      :error="getError('username')"
                      name="username"
            >
            </fg-input>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <fg-input type="email"
                      label="Email"
                      disabled
                      placeholder="Your email"
                      v-model="user.user_email"
                      name="email">
            </fg-input>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <fg-input type="password"
                      label="Contraseña Antigua"
                      placeholder="Contraseña"
                      v-model="user.password2"
                      v-validate="modelValidations.password2"
                      :error="getError('password2')"
                      name="password2">
            </fg-input>
          </div>
          <div class="col-md-6">
            <fg-input type="password"
                      label="Nueva Contraseña"
                      placeholder="Contraseña"
                      v-model="user.password"
                      v-validate="modelValidations.password"
                      :error="getError('password')"
                      name="password">
            </fg-input>
          </div>
        </div>
        <div class="text-right">
          <button type="submit" class="btn btn-filmker-pink btn-fill btn-sm" @click.prevent="validate">
            Actualizar Perfíl
          </button>
        </div>
        <div class="clearfix"></div>
      </form>
    </div>
  </card>
</template>
<script>
    import vueElementLoading from 'vue-element-loading'
    import swal from 'sweetalert2'
    import {EventBus} from '@/EventBus.js'

    export default {
        components: {
            vueElementLoading,
            swal
        },
        data() {
            return {
                loading: {
                    text: 'Please Wait',
                    color: '#222',
                    active: false
                },
                user: {
                    user_name: '',
                    user_address: '',
                    user_phone: '',
                    password: '',
                    dni: '',
                    username: '',
                    password2: '',
                    user_email: ''
                },
                account: {},
                modelValidations: {
                    fullName: {
                        required: true,
                        min: 2
                    },
                    username: {
                        required: true,
                        min: 2
                    },
                    email: {
                        email: true
                    },
                    password: {
                        required: true
                    },
                    password2: {
                        required: true
                    }
                }
            }
        },
        methods: {
            validate() {
                this.$validator.validateAll().then(isValid => {
                    if (isValid)
                        this.updateProfile();
                })
            },
            getError(fieldName) {
                return this.errors.first(fieldName)
            },
            updateProfile() {
                this.loading.active = true

                this.axios({
                    url: `verificacion.php`,
                    method: 'post',
                    data: {
                        password: this.user.password,
                        password2: this.user.password2,
                    },
                    headers: {
                        authorization: localStorage.token
                    }
                })
                    .then(response => {
                        console.log(response)
                        this.loading.active = false
                        this.showSwal('success', 'Actualizado exitosamente')
                    })
                    .catch(error => {
                        this.loading.active = false
                        this.showSwal('error', error.response.data.message)
                        console.log(error.response)
                    })
            },
            loadData() {
                let account = localStorage.account;
                account = JSON.parse(account)
                this.user.user_name = account.name
                this.user.user_email = account.mail
                this.user.username = account.mail
            },
            showSwal(type, message) {
                if (type === 'success') {
                    swal.fire({
                        title: message,
                        type: type
                    })
                }
                if (type === 'error') {
                    swal.fire({
                        title: message,
                        type: 'error'
                    })
                }
            }
        },
        created() {
            this.account = JSON.parse(localStorage.account)
            this.loadData()
        }
    }

</script>
<style>
  #edit_form label {
    color: #777 !important;
  }
</style>
